import './blogDetail.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {GetBlogById, GetBlogMedias, sendSubscribe} from "../../../redux/actions";
import {connect} from "react-redux";
import {useEffect, useRef, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import moment from "moment";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import NewsBlock from "../../../components/homepage/NewsBlock/NewsBlock";
import {InputGroup} from "../../../components/uiElements/inputGroup/InputGroup";
import {LoadingOutlined} from "@ant-design/icons";
import isEmail from "validator/es/lib/isEmail";
import {
    CopyIcon,
    FacebookIcon,
    LinkedinIcon, PageLeftArrIcon, PageRightArrIcon,
    PlayerIcon, SliderLeftArrIcon, SliderRightArrIcon, TelegramIcon, VideoStartIcon
} from "../../../assets/images";
import React from "react";
import {BLOGS_TYPE} from "../../../constants/constType";
import {CopyToClipboard} from "react-copy-to-clipboard/src";
import {WEB_PAGE_URL} from "../../../redux/api";
import {FacebookShareButton, LinkedinShareButton, OKIcon, OKShareButton} from "react-share";
import ImagesSlider from "../../../components/uiElements/modal/imagesSlider/ImagesSlider";
import VideoModal from "../../../components/uiElements/modal/VideoModal/VideoModal";
import Badge from "../../../components/uiElements/badge/Badge";


function BlogDetail(props) {
    const {requestLoading, staticTexts} = props
    const [sliderOpen, setSliderOpen] = useState(false)
    const [videoModalOpen, setVideoModalOpen] = useState(false)
    const [imgLoading, setImgLoading] = useState(true)
    const [imagePathList, setImagePathList] = useState([])
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const [email, setEmail] = useState('');
    const [type, setType] = useState(undefined);
    const [error, setError] = useState(false);
    const [blogById, setBlogById] = useState(null)
    const [blogMedias, setBlogMedias] = useState(null)
    const params = useParams()
    const shareUrl = `${WEB_PAGE_URL}/news/${params?.slug}`
    const [sliderCurrentActiveIndex, setSliderCurrentActiveIndex] = useState(0);
    const swiperRef = useRef(null);

    function toggleVideoModalOpen() {
        setVideoModalOpen(!videoModalOpen)
    }

    function openImagesSlider(modalImagePathList, imageIndex) {
        let imgList = []
        if (Array.isArray(modalImagePathList)) {
            imgList = modalImagePathList
        } else {
            imgList.push(modalImagePathList)
        }
        setSliderOpen(true)
        setCurrentImageIndex(imageIndex)
        setImagePathList(imgList)
    }

    function closeImagesSlider() {
        setSliderOpen(false)
        setCurrentImageIndex(0)
        setImagePathList([])
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        props.GetBlogById(params?.slug).then((blog) => {
            setBlogById(blog)
            props.GetBlogMedias(blog?.id).then((media) => {
                // console.log('blogMedias', media.medias.length)
                setBlogMedias(media)
            })
        })
    }, [params?.slug])

    useEffect(() => {
        Object.keys(BLOGS_TYPE).map(item => {
            if (BLOGS_TYPE[item] === blogById?.type) {
                setType(item)
            }
        })
    }, [blogById?.type])

    const getInputValues = (e) => {
        const {name, value} = e.target;
        setEmail(value);
        setError(false)
    };

    const sendSubscribe = () => {
        if (email && isEmail(email)) {
            props.sendSubscribe({email}).then(() => {
                setEmail(email)
            }, errorEmail => setError(!errorEmail)).finally(() => {
                setEmail('')
            })
        } else {
            setError(true)
        }
    }
    useEffect(() => {
        setEmail("")
        setError(false)
    }, [requestLoading])


    let sliderImages = blogMedias?.medias?.length > 5 ? blogMedias?.medias?.slice(5) : [];

    const WINDOW_SIZE = 5;

    return <div className={'blogDetail-wrapper'}>
        <div className={'blogDetail_block'}>
            <div className={'blogDetail-left-info'}>
                <div className={'blogDetail-img'}>
                    {
                        blogById?.type === BLOGS_TYPE?.video && (blogById?.youtubeLink || blogById?.video?.path)&&
                        <div className={'blogDetail-video-player'} onClick={toggleVideoModalOpen}>
                            <VideoStartIcon/>
                        </div>
                    }
                    {
                        <div className={'blogDetail-img-wrapper'}
                             onClick={() => blogById?.mediaMain && openImagesSlider(blogById?.mediaMain, 0)}>
                            <img
                                src={generateFileMediaUrl(blogById?.mediaMain?.detailPath || blogById?.mediaMain?.lightPath || blogById?.mediaMain?.path)}
                                loading={'eager'}
                                fetchpriority={'high'}
                                onLoad={() => setImgLoading(false)}
                                alt=""/>
                            {
                                imgLoading && <div className={'bg_grey'}/>
                            }
                        </div>
                    }
                    {
                        <div className={'blogDetail-type'}>
                            {blogById?.type && <Badge type={blogById?.type}/>}
                        </div>
                    }
                </div>
                {/*<div className={'blogDetail-link-info'}>*/}
                {/*    <Link to={'/'} className={'links'}>home</Link> <BreadcrumbsIcon/>*/}
                {/*    {*/}
                {/*        type && <Link to={`/${type}`} className={'links'}>{type}</Link>*/}
                {/*    }<BreadcrumbsIcon/>*/}
                {/*    <div className={'link-article'}>Article</div>*/}
                {/*</div>*/}
                <div className={'blogDetail-title'}>
                    {blogById?.title}
                </div>
                <div className={'blogDetail-date'}>
                    {moment(blogById?.date).format('ll')}
                </div>
                <div className={'blocks-description'} dangerouslySetInnerHTML={{__html: blogById?.description}}/>
                <div className={'blogDetail-medias-wrapper'}>
                    {
                        blogById?.medias?.length ? blogById?.medias?.slice(0, 5).map((item, index) => {
                            return <div className={'blogDetail-img'} key={item?.id}
                                        onClick={() => blogById?.medias && openImagesSlider(blogById?.medias, index)}>
                                <img src={generateFileMediaUrl(item?.lightPath || item?.path)}
                                     loading={'eager'}
                                     alt=""
                                />
                            </div>
                        }) : ''
                    }
                </div>
                {!!sliderImages?.length && <div className={'blogDetail-slider-wrapper'}>
                    <div className={'blogDetail_slider_title'}>
                        {staticTexts?.blog_slider_title} <span>{sliderImages?.length}</span>
                    </div>
                    <Swiper
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        onSlideChange={(swiper) => setSliderCurrentActiveIndex(swiper.activeIndex)}
                        spaceBetween={30}
                        centeredSlides={true}
                        // loop={true}
                        //lazy={true}
                        // className="mySwiper"
                        slidesPerView={1}
                        // freeMode={true}
                        navigation={false}
                        // modules={[Pagination,Autoplay, Navigation]}
                    >
                        {
                            sliderImages?.map((item, index) => {
                                const isVisible = Math.abs(index - sliderCurrentActiveIndex) <= WINDOW_SIZE;
                                if (!isVisible) {
                                    return <SwiperSlide key={item.id}/>;
                                }
                                return <SwiperSlide key={item.id}>
                                    <div className={'blogDetail-slider-img'} key={item?.id}
                                         onClick={() => blogById?.medias && openImagesSlider(blogMedias?.medias, index)}>
                                        <img src={generateFileMediaUrl(item?.lightPath || item?.path)}
                                             alt=""/>
                                    </div>
                                </SwiperSlide>
                            })
                        }
                    </Swiper>
                    {
                        sliderImages?.length > 1 ? <>
                            {sliderCurrentActiveIndex > 0 && <button className={`slider-btn  prev-btn`}
                                                                     onClick={() => {
                                                                         swiperRef.current?.slidePrev();
                                                                     }}>
                                <PageLeftArrIcon/>
                            </button>}
                            {sliderCurrentActiveIndex < (sliderImages?.length-1) && <button
                                className={`slider-btn next-btn`}
                                onClick={() => {
                                    swiperRef.current?.slideNext();
                                }}>
                                <PageRightArrIcon/>
                            </button>}
                        </> : ''
                    }
                </div>}
            </div>
            <div className={'blogDetail-right-info'}>
                <NewsBlock id={blogById?.id}/>
                <div className={'blogDetail-share'}>
                    <div className={'blogDetail-share-title'}>
                        {staticTexts?.blog_share_title}
                    </div>
                    <div className={'blogDetail-share-icons'}>
                        <CopyToClipboard text={shareUrl}>
                            <div onClick={e => {
                                e.stopPropagation()
                            }}
                                 className={'copy-share'}
                            >
                                <CopyIcon/>
                            </div>
                        </CopyToClipboard>
                        <FacebookShareButton url={shareUrl} quote={"ManeHblog"}>
                            <FacebookIcon/>
                        </FacebookShareButton>
                        <LinkedinShareButton url={shareUrl} title={'ManeHblog'} description={'ManeHblog'}>
                            <LinkedinIcon/>
                        </LinkedinShareButton>
                    </div>
                </div>
                <div className={'blogDetail-subscribe'}>
                    <div className={'subscribe-title'}>
                        {staticTexts?.homepage_subscribe_title}
                    </div>
                    <div className={'subscribe-input'}>
                        <InputGroup
                            inputType={'input'}
                            type={"text"}
                            value={email}
                            error={error}
                            name={'email'}
                            placeholder={staticTexts?.homepage_subscribe_placeholder}
                            maxLength={100}
                            onChange={getInputValues}
                        />

                        <button className='sent-email'
                                onClick={() => {
                                    if (!requestLoading && sendSubscribe) {
                                        sendSubscribe()
                                    }
                                }}>
                            {staticTexts?.homepage_subscribe_btn}
                            {
                                requestLoading ? <LoadingOutlined style={{fontSize: 14, color: "#fff"}}/>
                                    : ''
                            }

                        </button>
                    </div>
                </div>
            </div>
        </div>
        {sliderOpen && <ImagesSlider visible={sliderOpen}
                                     modalImagePathList={sliderImages}
                                     modalCurrentImageIndex={currentImageIndex}
                                     closeModal={closeImagesSlider}/>}
        <VideoModal item={blogById}
                    visible={videoModalOpen}
                    closeModal={toggleVideoModalOpen}/>
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'languages',
        'requestLoading',
    ])
};
const mapDispatchToProps = {
    GetBlogById,
    sendSubscribe,
    GetBlogMedias
};
export default connect(mapStateToProps, mapDispatchToProps)(BlogDetail);
